import React, {useContext, useEffect, useState} from "react";
import {Cookies, useCookies} from "react-cookie";
import {useNavigate} from "react-router-dom";
import {useSanctum} from "react-sanctum";
import {useToolkit} from './useToolkit';
import { v4 as uuidv4 } from 'uuid';
import {authLocalStorage} from "../config/global";

export const useAuthLocalStorage = () => {

    function setAuthLocalStorageKey(keyValue: any) {
        //console.log('setAuthLocalStorageKey: ' + keyValue);
        localStorage.setItem(authLocalStorage.authKey, JSON.stringify(keyValue));
    }
    function removeAuthLocalStorageKey() {
        //console.log('removeAuthLocalStorageKey');
        localStorage.removeItem(authLocalStorage.authKey);
    }
    function getAuthLocalStorageKey() : boolean | null {
        var k = localStorage.getItem(authLocalStorage.authKey);
        if(k)
            return JSON.parse(k) as boolean;
        else
            return false;
    }

    //const authLocalStorageSigned = JSON.parse(getAuthLocalStorageKey() || 'false') as boolean;


    return {
        setAuthLocalStorageKey,
        removeAuthLocalStorageKey,

        getAuthLocalStorageKey,
        //authLocalStorageSigned
    }
};
